import { defineMessages } from 'react-intl';

const _default_1: {
	to: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	transitionHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	anyStatus: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	to: {
		id: 'jira-workflow-editor.workflow-builder.transition.path.to',
		defaultMessage: 'to',
		description:
			'Text displayed between status names in a workflow transition visualization within the AI conversation interface, indicating the direction of a transition. Shown as text next to or between status labels (e.g., "To Do to In Progress"). The purpose is to clearly indicate the flow direction from one status to another in the workflow transition path.',
	},
	transitionHeading: {
		id: 'jira-workflow-editor.workflow-builder.transition-heading',
		defaultMessage: 'Transition',
		description:
			'Heading text displayed at the top of a transition card or section in the Jira workflow wizard within the AI conversation interface. Shown as a section header or card title. The purpose is to identify the section that contains workflow transition configuration options, helping users understand they are configuring how work items move between statuses.',
	},
	anyStatus: {
		id: 'jira-workflow-editor.workflow-builder.any-status',
		defaultMessage: 'Any Status',
		description:
			'Option text displayed in a status selector within the Jira workflow wizard in the AI conversation interface, representing a global transition that can be triggered from any status. Shown as a selectable option in a dropdown or list. When selected, it indicates that the transition can be initiated regardless of the current status. The purpose is to allow users to configure transitions that are available from any workflow status.',
	},
});
export default _default_1;
